module.exports = __webpack_public_path__ + "img/ma.7f0e2f35.png";